import React from 'react';
import { supplierDefs } from '@purchase/supplier';
import './XpcSection.less';

function formatRank(v: number | null | undefined): string {
  if (v == null) return '-';
  return `NO.${v}`;
}

function formatW(v: number | null | undefined): string {
  if (v == null) return '-';
  if (v >= 10000) return `${(v / 10000).toFixed(0)}w`;
  return String(v);
}

interface Metric {
  label: string;
  value: string;
}

export interface XpcOverallCardProps {
  data: supplierDefs.VendorXpcDashboardDto | null | undefined;
  className?: string;
}

export function XpcOverallCard({ data, className }: XpcOverallCardProps) {
  const metrics: Metric[] = [
    { label: '制作机构排名', value: formatRank(data?.productionRank) },
    { label: '广告机构排名', value: formatRank(data?.advertisingRank) },
    { label: '机构人气', value: formatW(data?.institutionPopularity) },
    { label: '粉丝', value: formatW(data?.institutionFans) },
    { label: '作品数', value: data?.opusCount != null ? String(data.opusCount) : '-' },
  ];

  return (
    <div className={`xpc-overall-card${className ? ` ${className}` : ''}`}>
      <div className="xpc-overall-card__source-info">
        <span>*数据来源于新片场</span>  
        {data?.crawlerTimestamp && <span>更新时间：{data.crawlerTimestamp}</span>}
      </div>
      <div className="xpc-overall-card__metrics">
        {metrics.map((m, i) => (
          <div key={i} className="xpc-overall-card__metric-item">
            <div className="xpc-overall-card__metric-label">{m.label}</div>
            <div className="xpc-overall-card__metric-value">{m.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}